module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-welcome-simple",
    class: [_vm.closing ? 'kiwi-welcome-simple--closing' : '']
  }, [_c('div', {
    staticClass: "kiwi-welcome-simple-section kiwi-welcome-simple-section-connection"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.greetingText)
    }
  }), _vm._v(" "), (!_vm.network || _vm.network.state === 'disconnected') ? [_c('form', {
    staticClass: "u-form kiwi-welcome-simple-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.formSubmit($event)
      }
    }
  }, [(_vm.network && _vm.network.state_error) ? _c('div', {
    staticClass: "kiwi-welcome-simple-error"
  }, [_vm._v("We couldn't connect to the server :( "), _c('span', [_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]) : _vm._e(), _vm._v(" "), (_vm.showNick) ? _c('input-text', {
    staticClass: "kiwi-welcome-simple-nick",
    attrs: {
      "label": _vm.$t('nick')
    },
    model: {
      value: (_vm.nick),
      callback: function($$v) {
        _vm.nick = $$v
      },
      expression: "nick"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPass) ? _c('label', {
    staticClass: "kiwi-welcome-simple-have-password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_password_box),
      expression: "show_password_box"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_password_box) ? _vm._i(_vm.show_password_box, null) > -1 : (_vm.show_password_box)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.show_password_box,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_password_box = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_password_box = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_password_box = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('password_have')) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.show_password_box) ? _c('input-text', {
    staticClass: "kiwi-welcome-simple-password",
    attrs: {
      "label": _vm.$t('password'),
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showChannel) ? _c('input-text', {
    staticClass: "kiwi-welcome-simple-channel",
    attrs: {
      "label": _vm.$t('channel')
    },
    model: {
      value: (_vm.channel),
      callback: function($$v) {
        _vm.channel = $$v
      },
      expression: "channel"
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "u-button u-button-primary u-submit kiwi-welcome-simple-start",
    attrs: {
      "type": "submit",
      "disabled": !_vm.readyToStart
    },
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    }
  })], 1)] : (_vm.network.state !== 'connected') ? [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    staticStyle: {
      "font-size": "2em",
      "margin-top": "1em"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "kiwi-welcome-simple-section kiwi-welcome-simple-section-info",
    style: (_vm.infoStyle)
  }, [(_vm.infoContent) ? _c('div', {
    staticClass: "kiwi-welcome-simple-section-info-content",
    domProps: {
      "innerHTML": _vm._s(_vm.infoContent)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c1b2e118!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/startups/Welcome.vue
// module id = 507
// module chunks = 2